import {Component, Inject, OnInit} from '@angular/core';
import {TitleComponent} from "../../components/ui/title/title.component";
import {ButtonComponent} from "../../components/ui/button/button.component";
import {Router, RouterLink} from "@angular/router";
import {SharedModule} from "../../shared/shared.module";
import {AuthenticationService} from "../../services/authentication.service";
import {MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService} from "@azure/msal-angular";
import {RedirectRequest} from "@azure/msal-browser";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    TitleComponent,
    ButtonComponent,
    RouterLink,
    SharedModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  loading = false;

  constructor(private authenticationService: AuthenticationService, private router: Router,
              private msalService: MsalService, @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration) {
  }

  async ngOnInit() {
    await this.authenticationService.initialize();
    const isAuthenticated = this.authenticationService.isLoggedIn();

    if (isAuthenticated) {
      await this.router.navigateByUrl('/panel/projects');
    }
  }

  login() {
    this.loading = true;

    this.msalService.loginRedirect({
      redirectStartPage: environment.msal.redirectUri,
      prompt: 'select_account',
      ...this.msalGuardConfig.authRequest
    } as RedirectRequest);
  }
}
